const orderList = () => import('@/views/my-order/orderList');
const orderDetail = () => import('@/views/my-order/orderDetail');
const orderFollow = () => import('@/views/my-order/orderFollow');
const placeOrder = () => import('@/views/my-order/placeOrder');
const confirmOrder = () => import('@/views/my-order/confirmOrder');
export default [{
		path: '/order-list',
		component: orderList,
		meta: [{
				name: '首页',
				url: './order-list',
			},
			{
				name: '我的订单',
				url: '',
			},
		],
	},

	{
		path: '/order-detail',
		component: orderDetail,
		meta: [{
				name: '首页',
				url: './order-list',
			},
			{
				name: '我的订单',
				url: './order-list',
			},
			{
				name: '订单详情',
				url: '',
			},
		],
	},

	{
		path: '/order-follow',
		component: orderFollow,
		meta: [{
				name: '首页',
				url: './order-list',
			},
			{
				name: '我的订单',
				url: './order-list',
			},
            {
            	name: '订单详情',
            	url: './order-detail',
            },
			{
				name: '订单进度',
				url: '',
			},
		],
	},

	{
		path: '/place-order',
		component: placeOrder,
		meta: [{
				name: '首页',
				url: './order-list',
			},
			{
				name: '立即下单',
				url: '',
			}
		]
	},

	{
		path: '/confirm-order',
		component: confirmOrder,
		meta: [{
				name: '首页',
				url: './order-list',
			},
			{
				name: '立即下单',
				url: '',
			}
		]
	}
]
